import { useEffect } from "react";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import { getQuickLinks } from "../../../../store/features/UserDashboard/NewUserDashboard/NewUserDashoardApi";
import { getRoleValue } from "../../../../pages/NewAcademicUser/Dashboard/VideoTourCard/getSlugByUserrole";
import { checkSelfPacedOrMultiRoleUser } from "../../../../helpers/utils/roleUtils";

function NavQuickLinks(props: any) {
  const { configState, navBg, normal, handleNavigation, showfilter } = props;
  const dashState: any = useAppSelector((store: RootStore) => {
    return store.NewDashboard;
  });
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });

  const isSelfPacedOrMultiRoleUser = checkSelfPacedOrMultiRoleUser(authState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (authState?.tac_user?.role) {
      dispatch(
        getQuickLinks(
          getRoleValue(
            authState?.tac_user?.role,
            authState,
            isSelfPacedOrMultiRoleUser
          )
        )
      );
    }
  }, [authState?.tac_user?.role, isSelfPacedOrMultiRoleUser]);

  return (
    <div
      className={`option__sections ${showfilter && "active"}  ${
        configState.themeMode === "light" && navBg && "light_mode"
      }  ${configState.themeMode === "light" && normal && "light_mode"}`}
    >
      {!dashState.loading.quick_links &&
        dashState.req_success.quick_links &&
        dashState.quick_links.map((link: any) => {
          return (
            <span
              role="button"
              aria-hidden
              className={` option ${
                configState.themeMode === "light" && navBg && "light_mode"
              }  ${
                configState.themeMode === "light" && normal && "light_mode"
              }`}
              key={link.id}
              onClick={() => handleNavigation(link)}
            >
              {" "}
              {link.title}
            </span>
          );
        })}
    </div>
  );
}

export default NavQuickLinks;
